import mai from './mai.js'
import com from './com.js'
import prd from './prd.js'
import fns from './fns.js'
import doc from './doc.js'
import tgr from './tgr.js'
import etc from './etc.js'

/**
    @description
        depth2: 화면목록 2depth,
        depth3: 화면목록 3depth,
        depth4: 화면목록 4depth,
        depth5: 화면목록 5depth,
        name: 화면목록 화면명,
        type: 화면목록 페이지 type,
        dir: 페이지 폴더명,
        id: 화면목록 프로그램ID,
        plan: 계획 완료일,
        end: 작업 완료일,
        user: 작업자 이름,
        state: 진행 상태 표시(진행, 컨펌, 최종완료, 수정, 삭제),
        etc: 수정사항 표시 쉼표(,) 로 구분하여 기술,
        uxw: ux라이팅 반영 여부,
*/

const PubRouter = [
    { title: '메인', titleId: 0 },
    ...mai,
    { title: '공통', titleId: 1 },
    ...com,
    { title: '상품몰', titleId: 2 },
    ...prd,
    { title: '금융서비스', titleId: 3 },
    ...fns,
    { title: 'IBK모임 서비스', titleId: 4 },
    ...tgr,    
    { title: '비대면서류접수', titleId: 5 },
    ...doc,
    { title: '기타', titleId: 6 },
    ...etc,
]

export default PubRouter
